import React, { useState, useEffect } from "react";
import { getAllTopRatings } from "../api/HomeApi.services"
import "./SlidingRatings.css";

function SlidingRatings() {

  const [allReviews, setAllReviews] = useState([]);

  const [visibleReviews, setVisibleReviews] = useState([]);

  const getAllTopReviews = async() => {
    const response = await getAllTopRatings();
    console.log('response', response);
    if(response?.length > 0) {
      setAllReviews(response);
      setVisibleReviews(response?.slice(0, 4));
    }
  }
useEffect(() => {
    getAllTopReviews();
}, []);

useEffect(() => {
  const interval = setInterval(() => {
    setVisibleReviews((prev) => {
      if (allReviews.length === 0) return prev;

      const firstIndex = allReviews.findIndex(r => r === prev[0]);
      const nextIndex = (firstIndex + 1) % allReviews.length;

      const nextVisible = [...prev.slice(1), allReviews[nextIndex]];
      return nextVisible;
    });
  }, 2000);

  return () => clearInterval(interval);
}, [allReviews]);


  return (
    <section className="sliding-ratings-section py-5">
      <h3 className="text-center mb-4">Over 300,00+ Happy Customers</h3>
      <div className="rating-carousel">
        {visibleReviews.map((review, index) => (
          <div key={index} className={`rating-card`}>
            <div className="stars">{`★`.repeat(review.rating)}</div>
            <p className="review-text">{review.comment}</p>
            <p className="review-name">- {review.user}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default SlidingRatings;
